// Live Search

/**
 * Variables
 */
const liveSearch = document.querySelector("[data-live-search]");
const liveSearchOpen = document.querySelector("[data-live-search-open]");
const liveSearchClose = document.querySelectorAll("[data-live-search-close]");
const liveSearchInput = document.querySelectorAll("[data-live-search-input]");
const liveSearchResults = document.querySelectorAll("[data-live-search-results]");
const liveSearchCategories = document.querySelectorAll("[data-live-search-categories]");
const liveSearchCategoriesTitles = document.querySelectorAll("[data-live-search-categories-title]");
const liveSearchPages = document.querySelectorAll("[data-live-search-pages]");
const liveSearchPagesTitles = document.querySelectorAll("[data-live-search-pages-title]");
const liveSearchProducts = document.querySelectorAll("[data-live-search-products]");
const liveSearchProductsHits = document.querySelectorAll("[data-live-search-products-hits]");
const liveSearchSubmit = document.querySelectorAll("[data-live-search-submit]");
const liveSearchSubmitHits = document.querySelectorAll("[data-live-search-submit-hits]");
const liveSearchOverlay = document.querySelector("[data-live-search-overlay]");
const liveSearchSuggestions = document.querySelectorAll("[data-live-search-suggestions]");

const forms = liveSearch.querySelectorAll('form[action="/search"]');

/**
 * Functions
 */
function debounce(func, delay) {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => func.apply(context, args), delay);
  };
}

const openLiveSearch = () => {
  liveSearch.classList.add("live-search--open");
  liveSearchOverlay.classList.add("live-search__overlay--active");

  document.querySelector('html').style.overflow = "hidden";

  liveSearchInput.forEach((input) => {
    input.focus();
    input.value = "";
  });
};

const closeLiveSearch = () => {
  liveSearch.classList.remove("live-search--open");
  liveSearchOverlay.classList.remove("live-search__overlay--active");

  document.querySelector("html").style.overflow = "initial";

  liveSearchResults.forEach((results) => {
    results.hidden = true;
  });

  liveSearchSuggestions.forEach((suggestions) => {
    suggestions.hidden = false;
  });

  liveSearchInput.forEach((input) => {
    input.value = "";
  });
};

const submitLiveSearch = () => {
  liveSearchInput.forEach((input) => {   
    if (input.value.length > 0) {
      const form = input.closest("form");
      
      if (form.hasAttribute('data-redirect')) {
        const redirect = form.getAttribute('data-redirect');
        window.location = redirect;
      } else {
        form.submit();
      }
    }
  });
};

const searchLiveSearch = (input) => {
  if (input.value.length > 0) {
    liveSearchSuggestions.forEach((suggestions) => {
      suggestions.hidden = true;
    });

    liveSearchResults.forEach((results) => {
      results.hidden = false;
    });

    liveSearchProducts.forEach((products) => {
      products.innerHTML = "";
    });

    liveSearchCategories.forEach((categories) => {
      categories.innerHTML = "";
    });

    liveSearchPages.forEach((pages) => {
      pages.innerHTML = "";
    });

    Clerk(
      "call",
      "search/predictive",
      {
        key: theme.strings.clerkApiKey,
        query: input.value,
        limit: 8,
        labels: ["CLERK - Live Search - Products"],
        attributes: [
          "id",
          "name",
          "url",
          "image",
          "price",
          "list_price",
          "on_sale",
        ],
      },
      function (response) {
        liveSearchProductsHits.forEach((hits) => {
          if (response.hits > 0) {
            hits.innerHTML = `(${response.hits} ${theme.strings.results})`;
          } else {
            hits.innerHTML = `(0 ${theme.strings.results})`;
          }
        });

        liveSearchSubmit.forEach((submit) => {
          submit.hidden = response.hits <= 7;
        });

        forms.forEach((form) => {
          if (response.redirect) {
            form.setAttribute('data-redirect', response.redirect);
          }
        });

        liveSearchSubmitHits.forEach((hits) => {
          hits.innerHTML = `(${response.hits})`;
        });

        response.product_data.forEach((product) => {
          const productObj = {
            productId: product.id,
            productUrl: product.url,
            productImage: product.image,
            productName: product.name,
            productPrice: product.price,
            productPriceList: product.list_price,
            productOnSale: product.on_sale,
          }

          liveSearchProducts.forEach((products) => {
            products.innerHTML += window.theme.templates.buildProductItem(productObj, 'live-search');
          });
        });

        window.Clerk("click", "*[data-clerk-product-id]");
      }
    );

    Clerk(
      "call",
      "search/categories",
      {
        key: theme.strings.clerkApiKey,
        query: input.value,
        limit: 8,
        labels: ["CLERK - Live Search - Categories"],
      },
      function (response) {
        liveSearchCategoriesTitles.forEach((title) => {
          if (response.categories.length > 0) {
            title.hidden = false;
          } else {
            title.hidden = true;
          }
        });

        response.categories.forEach((category) => {
          const categoryUrl = category.url;
          const categoryName = category.name;

          liveSearchCategories.forEach((categories) => {
            categories.innerHTML += `
                <li class="live-search__results__content__categories__list-item">
                  <a href="${categoryUrl}">
                    ${categoryName}
                  </a>
                </li>
              `;
          });
        });
      }
    );

    Clerk(
      "call",
      "search/pages",
      {
        key: theme.strings.clerkApiKey,
        query: input.value,
        limit: 8,
        labels: ["CLERK - Live Search - Categories"],
      },
      function (response) {
        liveSearchPagesTitles.forEach((title) => {
          if (response.pages.length > 0) {
            title.hidden = false;
          } else {
            title.hidden = true;
          }
        });

        response.pages.forEach((page) => {
          const pageUrl = page.url;
          const pageTitle = page.title;

          liveSearchPages.forEach((pages) => {
            pages.innerHTML += `
                <li class="live-search__results__content__pages__list-item">
                  <a href="${pageUrl}">
                    ${pageTitle}
                  </a>
                </li>
              `;
          });
        });
      }
    );
  } else {
    liveSearchResults.forEach((results) => {
      results.hidden = true;
    });

    liveSearchSuggestions.forEach((suggestions) => {
      suggestions.hidden = false;
    });
  }
};

/**
 * Events
 */
liveSearchOpen.addEventListener("click", openLiveSearch);

liveSearchOverlay.addEventListener("click", closeLiveSearch);

liveSearchClose.forEach((close) => {
  close.addEventListener("click", closeLiveSearch);
});

liveSearchSubmit.forEach((submit) => {
  submit.addEventListener("click", submitLiveSearch);
});

liveSearchInput.forEach((input) => {
  input.addEventListener("keyup", debounce(() => {
      searchLiveSearch(input);
    }, 250)
  );
});

forms.forEach((form) => {
  form.addEventListener("submit", (event) => {
    if (form.hasAttribute('data-redirect')) {
      event.preventDefault();

      const redirect = form.getAttribute('data-redirect');
      window.location = redirect;
    }
  });
});